import { jsx as _jsx, Fragment as _Fragment, jsxs as _jsxs } from "react/jsx-runtime";
export function RightText(props) {
    const { x, y, label } = props;
    const labelPosition = `translate(${x},${y})`;
    return (_jsxs(_Fragment, { children: [_jsx("text", { textAnchor: "end", transform: labelPosition, stroke: "rgba(255,255,255,0.5)", strokeWidth: "0.5em", fill: "none", fontSize: "14", children: label }), _jsx("text", { textAnchor: "end", transform: labelPosition, stroke: "none", fontSize: "14", fill: "black", children: label })] }));
}
//# sourceMappingURL=RightText.js.map